module.exports = __webpack_public_path__ + "static/media/salesforceProcess2.39598dc2.png";